import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { makeGetIsRetiredSelector } from "~/store/selectors/selector.configOptions";

export const NotRetired = ({ children, redirectTo }) => {
  const getIsRetired = useMemo(() => {
    return makeGetIsRetiredSelector();
  }, []);
  const isAccountRetired = useSelector(getIsRetired);

  return isAccountRetired ? children : <Navigate to={redirectTo} />;
};

NotRetired.propTypes = {
  redirectTo: PropTypes.string,
  children: PropTypes.any,
};

NotRetired.defaultProps = {
  redirectTo: "/projects",
};
